import React from 'react'
import { Link } from 'react-router-dom'
import erimg from '../../../assets/images/error-404.png'

const ErrorNotFound = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className="error-404-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="content clearfix">
                            <div className="error">
                                <img src={erimg} alt="" />
                            </div>
                            <div className="error-message">
                                <h3>404! Page non trouvée</h3>
                                <p>Nous sommes désolés mais nous ne parvenons pas à trouver la page que vous avez demandée. Cela peut être dû à une erreur de saisie de l'adresse Web.</p>
                                <Link onClick={ClickHandler} to="/" className="theme-btn"><i className="fa fa-angle-double-left"></i> Retour à l'accueil</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ErrorNotFound